import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckCircle2 } from "lucide-react";
import Logo from "@/components/Logo";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("Lösenordet måste vara minst 8 tecken"); return; }
    if (password !== confirm) { toast.error("Lösenorden matchar inte"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => nav("/login", { replace: true }), 2000);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Kunde inte återställa lösenord");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-5 py-10">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl p-8">
        {!done ? (
          <>
            <div className="mb-6">
              <Logo variant="inline" size="md"/>
            </div>
            <h1 className="font-heading text-3xl font-extrabold text-slate-900 mb-1">Välj nytt lösenord</h1>
            <p className="text-sm text-slate-500 mb-6">Ange ett nytt lösenord som är minst 8 tecken.</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label>Nytt lösenord</Label>
                <Input required type="password" data-testid="rp-password" value={password} onChange={e => setPassword(e.target.value)} className="h-11"/>
              </div>
              <div className="space-y-2">
                <Label>Bekräfta lösenord</Label>
                <Input required type="password" data-testid="rp-confirm" value={confirm} onChange={e => setConfirm(e.target.value)} className="h-11"/>
              </div>
              <Button type="submit" data-testid="rp-submit" disabled={loading}
                className="w-full h-12 bg-[#E1251B] hover:bg-[#C81D14] text-white font-semibold rounded-full">
                {loading ? "Sparar…" : "Spara nytt lösenord"}
              </Button>
            </form>
          </>
        ) : (
          <div className="text-center py-6" data-testid="rp-success">
            <div className="w-14 h-14 rounded-full bg-emerald-100 mx-auto flex items-center justify-center mb-4">
              <CheckCircle2 className="text-emerald-600" size={28}/>
            </div>
            <h2 className="font-heading text-2xl font-extrabold text-slate-900">Lösenord uppdaterat</h2>
            <p className="text-sm text-slate-600 mt-2">Du skickas nu till inloggningen.</p>
          </div>
        )}
      </div>
    </div>
  );
}
